module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-database-1.9abecd52.svg";